import { h, Component } from 'preact';

export default class Button extends Component {
  constructor(props) {
    super(props);
  }

  render({ onButtonClick, isDisabled, name }) {
    return (
      <button class="btn btn-primary save" onClick={onButtonClick} disabled={isDisabled || false}>
        {name}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/button/index.js